
export default function Home() {
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen bg-white px-4">
      <div className="flex flex-col items-center justify-center space-y-12">
        {/* Logo */}
        <div className="w-full max-w-2xl">
          <img 
            src="https://static.readdy.ai/image/c1d3a3065b1a0920ec31881e87c350dd/726e26e6205829a9a3238145fc004efe.png" 
            alt="NEU-CONNECTIONS Clinical Neuroplasticity Services"
            className="w-full h-auto"
          />
        </div>

        {/* Coming Soon */}
        <div className="text-center space-y-6">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900">
            Coming Soon
          </h1>
          
          {/* Contact */}
          <div className="flex items-center justify-center space-x-3 text-lg md:text-xl text-gray-700">
            <i className="ri-mail-line text-2xl"></i>
            <a 
              href="mailto:enquire@neuconnections.org" 
              className="hover:text-cyan-500 transition-colors duration-300"
            >
              enquire@neuconnections.org
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
